import BadgeTested from '../../public/badge-tested.svg';
import BadgeVerified from '../../public/badge-verified.svg';
import BadgeVerifiedCheck from '../../public/badge-verified-check.svg';
import BadgeRated from '../../public/badge-quality.svg';

export const RatingBadge = ({ version }) => {
  return (
    <div style={{ transform: "scale(0.9)" }}>
      {version === 'badge-rated' && <BadgeRated />}
      {version === 'badge-tested' && <BadgeTested />}
      {version === 'badge-verified' && <BadgeVerified />}
      {version === 'badge-verified-check' && <BadgeVerifiedCheck />}
    </div>
  );
};
